// extracted by mini-css-extract-plugin
export default {"loginWrapper":"loginWrapper__vAcA1","inputWrapper":"inputWrapper__y_eqt","alreadyRegistered":"alreadyRegistered__Jf3F0","checkboxInput":"checkboxInput__XIF_A","moreOptions":"moreOptions__qIDbU","extraTopMargin":"extraTopMargin__jQxAD","rememberMe":"rememberMe__fDKrK","forgotPassword":"forgotPassword__Z5LSu","forgotPasswordLink":"forgotPasswordLink__QmXLL","tabbedForm":"tabbedForm__xXypL","ippWrapper":"ippWrapper__SyhdQ","extendedLoginWrapper":"extendedLoginWrapper__S3J91","showExtended":"showExtended__RmkHK","hideExtended":"hideExtended__Kcx5u","arrowOpened":"arrowOpened__xbIvm"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"loginWrapper\":\"loginWrapper__vAcA1\",\"inputWrapper\":\"inputWrapper__y_eqt\",\"alreadyRegistered\":\"alreadyRegistered__Jf3F0\",\"checkboxInput\":\"checkboxInput__XIF_A\",\"moreOptions\":\"moreOptions__qIDbU\",\"extraTopMargin\":\"extraTopMargin__jQxAD\",\"rememberMe\":\"rememberMe__fDKrK\",\"forgotPassword\":\"forgotPassword__Z5LSu\",\"forgotPasswordLink\":\"forgotPasswordLink__QmXLL\",\"tabbedForm\":\"tabbedForm__xXypL\",\"ippWrapper\":\"ippWrapper__SyhdQ\",\"extendedLoginWrapper\":\"extendedLoginWrapper__S3J91\",\"showExtended\":\"showExtended__RmkHK\",\"hideExtended\":\"hideExtended__Kcx5u\",\"arrowOpened\":\"arrowOpened__xbIvm\"}";
        // 1787130556871
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  